/**
 * Unicode Normalisation names
 *
 * List of blocks https://www.unicode.org/reports/tr15/tr15-53.html#Norm_Forms
 * Usage in regex documentation https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Unicode_Property_Escapes
 */
export abstract class UnicodeNormalizations {
  static readonly CANON_DECOMP = 'NFD'; // Canonical Decomposition
  static readonly CANON_DECOMP_WITH_CANON_COMP = 'NFC'; // Canonical Decomposition followed by Canonical Composition
  static readonly COMPAT_DECOMP = 'NFKD'; // Compatibility Decomposition
  static readonly COMPAT_DECOMP_WITH_CANON_COMP = 'NFKC'; // Compatibility Decomposition followed by Canonical Composition
}
